import { AnbBaseFormComponent, AnbFormGroup } from '@anb/ng-forms';
import { FormControl, ValidatorFn, Validators } from '@angular/forms';

export interface CustomErrorMap {
  control: string;
  key:
    | 'required'
    | 'pattern'
    | 'min'
    | 'max'
    | 'sum'
    | 'invalid'
    | 'minlength'
    | 'maxlength'
    | 'futureDate'
    | 'futureTime'
    | 'lengthLinkerOnderkaakLowerLimit'
    | 'lengthLinkerOnderkaakMaxLimit';
  error: string;
}

export abstract class BaseFormComponent extends AnbBaseFormComponent {
  // readonly roleEnum = RoleEnum;
  abstract form: AnbFormGroup;
}

export function requires(required: boolean, control: FormControl, validators: ValidatorFn | ValidatorFn[] | null = []) {
  if (!Array.isArray(validators)) {
    validators = [validators];
  }

  control?.setValidators(!required ? [...validators] : [Validators.required, ...validators]);
  control?.updateValueAndValidity({ emitEvent: false });
}
